import { EngagementOptionEnumValues, ExchangeTypeEnumValues, IntegrationStatusEnumValues } from '@forgd/shared/enums'
import { z } from 'zod'

export const MarketMakerSchema = z.object({
  id: z.string(),
  name: z.string(),
  isDemo: z.boolean(),
  includeOnDepthLeaderboard: z.boolean(),
  includeOnSpreadLeaderboard: z.boolean(),
  includeOnVolumeLeaderboard: z.boolean(),
  canAccessRfqs: z.boolean(),
  description: z.string().nullable(),
  countryCode: z.string().nullable(),
  website: z.string().nullable(),
  imageUrl: z.string().nullable(),
  importName: z.string().nullable(),
  services: z.array(z.string()).nullable(),
  isTelegramBotNotificationsEnabled: z.boolean(),
  engagementOptions: z.array(z.enum(EngagementOptionEnumValues)).nullable(),
})

const MmExchangeSchema = z.object({
  value: z.string(),
  label: z.string(),
  url: z.string().nullable().optional(),
  type: z.enum(ExchangeTypeEnumValues),
  order: z.number().safe().nullable(),
})

export const MarketMakerDetailsSchema = MarketMakerSchema.pick({
  id: true,
  name: true,
  description: true,
  imageUrl: true,
  engagementOptions: true,
  services: true,
  countryCode: true,
  website: true,
}).extend({
  integrationStatus: z.enum(IntegrationStatusEnumValues),
  activeEngagementsCount: z.number().safe(),
  averageFDV: z.number().safe(),
  supportedCEX: z.array(MmExchangeSchema),
  supportedDEX: z.array(MmExchangeSchema),
})

export type MarketMakerDetailsType = z.infer<typeof MarketMakerDetailsSchema>

export const MarketMakersListQuerySchema = z.object({
  integrationStatus: z.enum(IntegrationStatusEnumValues).optional(),
})

export const MarketMakerListItemSchema = MarketMakerSchema.pick({
  id: true,
  name: true,
  imageUrl: true,
}).extend({
  integrationStatus: z.enum(IntegrationStatusEnumValues),
})

export const MarketMakersListResponseSchema = z.array(MarketMakerListItemSchema)

export type MarketMakerListItemType = z.infer<typeof MarketMakerListItemSchema>

export const MarketMakerLeaderboardOptIns = z.object({
  includeOnDepthLeaderboard: z.boolean(),
  includeOnSpreadLeaderboard: z.boolean(),
  includeOnVolumeLeaderboard: z.boolean(),
  includeOnKpiAdherenceLeaderboard: z.boolean(),
})

export const UpdateMarketMakerLeaderboardOptIns = MarketMakerLeaderboardOptIns.partial()

export type UpdateMarketMakerLeaderboardOptInsType = z.infer<typeof UpdateMarketMakerLeaderboardOptIns>
export const GetMarketMakerProfileResponse = MarketMakerSchema.pick({
  name: true,
  imageUrl: true,
  services: true,
  engagementOptions: true,
  description: true,
  countryCode: true,
  website: true,
  isTelegramBotNotificationsEnabled: true,
}).extend({
  exchanges: z.array(z.string()),
})
export const UpdateMarketMakerProfileRequest = GetMarketMakerProfileResponse.omit({ exchanges: true })
  .partial()
  .extend({
    exchanges: z.array(z.string()).optional(),
  })

export const InviteClientsToForgdQuerySchema = z.object({
  emails: z.array(z.string().email()),
})

export * from './claim'
export * from './connect'
export * from './leaderboard'
export * from './reports'
export * from './drop-records'
export * from './supported-lists'
